var msg = new Array();
msg['ERR_PRIVACY']='You must accept the conditions';
msg['ERR_MISSINGFIELDS']='Complete all required fields correctly';
msg['ERR_FILLEMAILFIELD']='Fill in the email field';
msg['ERR_USEREXISTS']='The email address is already registered. Please login';
msg['ERR_INVALIDMAIL']='Invalid email';
msg['ERR_CLIENTMANDATORYFIELDS']='Fields marked are mandatory';
msg['ERR_NOSIZESELECTED']='You must first select a size';
msg['ERR_LOGINREQUIRED']='You must log in';
msg['ERR_LOGININVALID']='Invalid email or password';
msg['ERR_CONFIRMPASSWORD']='Passwords do not match';
msg['ERR_MINLENGTH']='Must be at least :length characters';
msg['ERR_CARRIERMISSING']='You must select a shipping method';
msg['ERR_CARRIER_COST_MISSING']='No rate applicable for country, carrier and order weight';
msg['ERR_FILE_TOO_LARGE']='The uploaded file is too large, maximum size is :size';
msg['ERR_MIN_LENGTH']='The :field field must have at least :length characters';
msg['ERR_PEC_OR_SDI_REQUIRED']='Fill in at least one field between PEC and SDI';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Only order booking will be enabled and shipping fees will be communicated by email';
msg['MSG_REMOVEDFROMCART']='Product removed from cart';
msg['MSG_DELETEALLPRODUCTS']='Are you sure you want to delete all products from the cart?';
msg['DELETEALLPRODUCTSERROR']='Error removing products from cart';
msg['MSG_ADDEDTOCART']='Products added to cart';
msg['MSG_WAIT']='Please wait...';
msg['MSG_SUBJECT_PRODUCT_SHARE']=' has shared something with you';
msg['MSG_SENDER_PRODUCTSHARE']='Your name';
msg['MSG_MESSAGE_PRODUCTSHARE']='Message';
msg['MSG_MAILSENT']='Emails sent';
msg['MSG_MIXED_INTANGIBLE']='Products in the cart cannot be purchased together with the selected product';
msg['MSG_MIXED_CART']='Products in the cart cannot be purchased together with the selected product because they are in different warehouses';
msg['MSG_INSUFFICIENT_STOCK']='At the moment the product availability is not sufficient';
msg['MSG_APPLIEDVATCHANGED']='After this update of billing data, the VAT applied to your order has changed';
msg['MSG_GENERIC_ERROR']='Sorry, an error occurred';
msg['MSG_COUPON_ERROR']='Invalid coupon code or previously entered';
msg['MSG_COUPON_VALID']='Coupon code entered successfully validated';
msg['MSG_RECOVEREMAILSENT']='Check your email and insert the code to confirm the change';
msg['MSG_RECOVEREMAILSENT_ERROR']='Warning: You are not registered with this email address or you are already resetting a new password';
msg['MSG_EXTRAUELIMIT']='The minimum order amount is 2000.00 €';
msg['MSG_PASSWORDUPDATED']='Password updated';
msg['MSG_RULE_REJECT']='The product cannot be added to the cart because of rule :rule';
msg['LABEL_ARTICLES']='items';
msg['LABEL_WARNING']='Warning';
msg['LABEL_NOTAPPLICABLE']='Not applicable';
msg['LABEL_ALREADYREGISTEREDUSERES']='Already registered users';
msg['LABEL_SENTINVITES']='Invites sent';
msg['LABEL_NOTSENTINVITES']='Invites not sent';
msg['LABEL_INVITES_ALREADY_SENT']='Users already invited';
msg['LABEL_SUBMIT']='Submit';
msg['LABEL_SELECTALL']='Select all';
msg['MSG_MESSAGE_SENT']='Message sent!';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Return request created successfully';
msg['MSG_RETURN_REQUEST_ALREADY_EXISTS'] = 'Return request already made';
msg['MSG_SAVE_SUCCESS'] = 'Save successful';
msg['MSG_SUBSCRIBED'] = 'Subscribed successfully';
msg['MSG_PROFILECONSENT_SAVED'] = 'Your contact preferences have been updated';
msg['MSG_SAMPLE_NOT_FOUND']='No sample was found for the chosen product';
msg['MSG_NEWSLETTER_COMPLETED']='Subscription completed successfully';
msg['MSG_INVALID_CAPTCHA'] ='Invalid captcha code';
msg['MSG_USER_ALREADY_REGISTERED'] ='User already registered';
msg['MSG_CONFIRM_BOOKING'] = "Do you confirm you want to pay by bank transfer?";
msg['MSG_CONFIRM_COD'] = "Do you confirm you want to pay by cash on delivery?";
msg["MSG_CONFIRM_CART_RESET"] = "Are you sure you want to create a new shopping cart?";
msg["ERR_CART_RESET"] = "An error occurred while resetting the shopping cart. Please try clearing the shopping cart manually.";
msg['MSG_PASSWORD_OK'] ='Password has been reset successfully';
msg['msg.order.expiredcart'] ='Your cart has expired';
msg['msg.order.missingquantities'] ='One or more products are not available in the requested quantity or for the selected shipping country';
msg['A reset email has already been sent.']='Password recovery email already sent';
msg['No user found']='User not found';
msg['Procedura di recupero password non abilitata per utenti non attivi.']='Password recovery procedure not enabled for inactive users';
msg['msg.form.invalidtype'] = 'An error occurred. Contact the administration reporting the following: "Invalid or missing contact type."';
msg['msg.form.invalidemail'] = 'Invalid or missing email';
msg['msg.form.invalidrecipients'] = 'An error occurred. Contact the administration reporting the following: "Invalid or missing contact recipients."';
msg['login.user.unexisting']='User does not exist';

var portal_livestock_available='AVAILABLE';
var portal_livestock_soldout='SOLD OUT';

var activity_online_shop = 'online store';
var activity_shop = 'store';
var activity_private_sales = 'private sales';
var activity_outlet = 'outlet';
var activity_online_outlet = 'online outlet';
var activity_store_chain = 'store chain';
var activity_purchasing_group = 'buying group';
var activity_broker = 'broker/agent';
var activity_ebay_amazon = 'ebay/amazon store';
var activity_other = 'other';

var general="General";
var general_personaldata='Personal data';
var general_olduser='Registered user';
var general_newuser='New user';
var general_username="Username";
var general_password="Password";
var general_contacts="Contacts";
var general_choosesize="Select options";
var general_phone="Phone";
var general_skype="Skype";
var general_website="WebSite";
var general_fax="Fax";
var general_firstname='First name';
var general_lastname='Last name';
var general_company='Company';
var general_birth='Date of birth';
var general_code='Code';
var general_model='Model';
var general_quantity='Quantity';
var general_availability='Availability';
var general_price='Price';
var general_warning='Warning';
var general_dispatchto='Recipient';
var general_careof='C/O';
var general_vat='Tax ID / VAT No.';
var general_address='Address';
var general_addresstype='Address type';
var general_addressnumber='House number';
var general_city='City';
var general_prov='State/Province';
var general_zip='ZIP';
var general_mobile='Mobile';
var general_notes='Notes';
var general_orders='Orders';
var general_fgfdiscounts='Referrals and discounts';
var general_myprofile='My profile';
var general_pieces='pcs';
var general_size_table='Size table';
var general_details='Details';
var general_invoice='Invoice';
var general_creditnote='Credit note';
var general_cart= 'Cart';
var general_country='Country';
var general_carrier='Carrier';
var general_dispatch_address='Shipping address';
var general_invoice_address='Billing address';
var general_receive_newsletter='Receive Newsletter';
var general_copydispatchfrombilldata='Copy from billing data';
var general_instructions="Instructions";
var general_add="Add";
var general_status="Status";
var general_toomanyfilters="You have reached the maximum number of allowed filters.";

var help_addresstype='Street, Square, Avenue, ...';
var help_address='Enter the street name';
var help_dispatchmobile='Enter a phone number on which to be contacted for delivery';
var help_ordercfpiva='Leaving this field blank will apply the default VAT to the order value';
var help_cf='Enter your tax code';

var buttons_save='Save';
var buttons_changepw='Change password';
var buttons_close='Close';
var buttons_continue='Continue';
var buttons_confirm='Confirm';
var buttons_cancel='Cancel';
var buttons_invite='Invite';
var buttons_continueshopping='Continue shopping';
var buttons_gocheckout='Go to cart';

var messages_product_soldout='The product is sold out';
var messages_noselection='The selection is empty';
var messages_invaliddata='Fill in all fields correctly';
var messages_recoverpassword='Recover password';
var messages_recoverpassword_info='Enter the email address with which you registered. <br/>You will be sent an email with instructions to set a new password';
var messages_invitefriends='Invite friends';
var messages_confirmpassword='Confirm password';
var messages_sendingmail='Sending email in progress...';
var messages_mailsent='Email sent successfully';
var messages_password='Password';
var messages_confirmpassword='Confirm password';
var messages_requiredfield='Required field';

var subscribe_personaldata='Processing of data';
var subscribe_privacyintro='To proceed with registration it is necessary to read the privacy regulations and give authorization for the processing of personal data';
var subscribe_privacydisclaimer='You must accept the privacy policy to complete registration.'
var subscribe_privacy1='I certify that I have read and accepted the privacy policy';
var subscribe_privacy2='I authorize the sharing of my data with third parties for commercial purposes (optional)';
var order_status='Status'
var order_date='Date'
var order_dispatchdate='Dispatched';

var returnedgoods_requests="Your return requests";
var returnedgoods_motivations="Reason for return";
var returnedgoods_requestcode="Return code";
var returnedgoods_requestdate="Requested on";
var returnedgoods_motivations_1="I changed my mind";
var returnedgoods_motivations_2="The product is too big/small";
var returnedgoods_motivations_3="The product is damaged";
var returnedgoods_motivations_4="The product received does not match the product ordered";
var returnedgoods_motivations_5="The product is not present in the package";
var returnedgoods_motivations_other="Other";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='Pending';
i18nOrderStatus[1]='Awaiting payment';
i18nOrderStatus[2]='Confirmed';
i18nOrderStatus[3]='Shipped';
i18nOrderStatus[4]='Delivered';
i18nOrderStatus[5]='Booked';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='Cancelled';
i18nOrderStatus[2001]='Error';
i18nOrderStatus[3001]='In progress';
i18nOrderStatus[3002]='Ready';

i18nOrderStatus[1000]='Payment Cancelled';
i18nOrderStatus[2002]='Payment verification failed';
i18nOrderStatus[2003]='Refunded';
i18nOrderStatus[2005]='Rejected';
i18nOrderStatus[3003]='Not shippable';
i18nOrderStatus[5001]='Not authorized';
i18nOrderStatus[5002]='Authorized';
i18nOrderStatus[5003]='Dropshipping - Growing';
